export default __webpack_public_path__ + "static/media/questionBg.f48fb1f1.png";